import { ProductType } from '../product/product';
import { TradingSystem } from '../trading-system';

export interface IdIdentifier {
  _id: string;
}

export interface TimeIdentifiers {
  createdAt: string;
  updatedAt: string;
}

export interface DeletedIdentifier {
  deletedAt?: Date;
}

export interface UserIdentifier {
  userId: string;
}

export interface AccountIdentifier {
  accountId: string;
}

export interface ProgramIdentifier {
  programId: string;
}

export interface ProductIdentifier {
  productId: string;
  productType: ProductType;
}

export interface TradingSystemIdentifier {
  tradingSystem: TradingSystem;
}

export interface PurchaseIdentifier {
  purchaseId: string;
}

export type BaseIdentifiers = IdIdentifier & TimeIdentifiers;

export enum UnavailableValue {
  Dash = '----',
}
